import * as types from "./types";

const mutations = {
    [types.LOADING_DESIGNATION](state, value) {
        state.loading = value;
    },
    [types.GET_DESIGNATION_LIST](state, designations) {
        state.designations = designations;
    },
    [types.REMOVE_DESIGNATION](state, id) {        
        state.designations = state.designations.filter((x) => x.id !== id);        
    },
    [types.ADD_DESIGNATION](state, designation) {        
        state.designations.unshift(designation);
    },
    [types.UPDATE_DESIGNATION](state, designation) {        
        const designationIndex = state.designations.findIndex((x) => x.id === designation.id);
        state.designations[designationIndex] = designation;        
    },
    [types.GET_DESIGNATIONBYID](state, designationId) {
        state.designationId = designationId;
    }
};

export default mutations;